let mapJsonDataURL;

window.addEventListener('load', () => {

    if (typeof window.cnfsdInteractiveMApLoaded !== 'undefined') {
		return;
	}

    const maps = document.querySelectorAll('.mod-interactive-map');
    if (!maps) return;
  
    const mapConfig = {
        partialAttributeName: 'data-map-id',
        fillColourDefault: '#FAF8F8',
        strokeColourDefault: 'rgba(31, 31, 31, .15)',
        interactiveFillColourInactive: '#EFEFEF',
        interactiveFillColourActive: '#58AAE0',
        interactiveStrokeColour: '#1F1F1F'
    }



    class InteractiveMapDefaultSetter {

        // SET PATHS DEFAULT
        static setDefaultPathColours(path) {
            InteractiveMapHelpers.updatePathColourHelper(path, mapConfig.fillColourDefault);
            path.setAttribute('stroke', mapConfig.strokeColourDefault);
        }

        // SET ATTRIBUTES TO DEFAULT
        static setDefaultMapAttributes(mapElement) {
            mapElement.setAttribute('aria-live', 'polite');
            mapElement.setAttribute('aria-label', 'Press enter to interact with the map.');
        }

        //SET THE DEFAULT COLOUR OF INTERACTIVE REGIONS
        static setInteractivePathStateInactiveState(path) {
            InteractiveMapHelpers.updatePathColourHelper(path, mapConfig.interactiveFillColourInactive);
            path.setAttribute('stroke', mapConfig.interactiveStrokeColour);
            path.classList.add('interactive');
        }        
    }


    class InteractiveMapHelpers {

        // LOOP THROUGH PATH ATTRIBUTES AND MATCH ANY DATA-MAP-ID{ANYTHING} ATTRIBUTES
        static findMatchingAttributeHelper = (path, callback) => {
            for (const attribute of path.attributes) {
                const attributeName = attribute.name;
                const attributeValue = attribute.value;

                if (attributeName.toLowerCase().includes(mapConfig.partialAttributeName.toLowerCase())) {
                    callback(attributeValue, path);
                }
            }
        }

        static updatePathColourHelper(path, colour) {
            if (path) path.setAttribute('fill', colour);
        }


        static findSelectedRegionByAttributeHelper = (interactivePathsObject, matchingAttribute) => {
            return Object.entries(interactivePathsObject).find(([key]) => key === matchingAttribute);
        }

        static pathLooperHelper = (paths, callback, colour) => {
            if (!paths || !callback) return;

            if (Array.isArray(paths)) {
                paths.forEach(path => {
                    callback(path, colour ?? null);
                })
            } else {
                callback(paths, colour ?? null);
            }
        }

        static regionParser = (region) => {
            return region.replaceAll('_', ' ');
        }

        static setPathTabIndexHelper = (path, index) => {
            path.tabIndex = index;
        }

        static toggleElementVisibility = (element, isVisible) => {
            if (isVisible) {
                element.style.visibility = 'visible';
            } else {
                element.style.visibility = 'hidden';
            }
        }


        static toggleElementDisplay = (element, isVisible) => {
            if (isVisible) {
                element.style.display = 'block';
            } else {
                element.style.display = 'none';
            }
        }
    }



    class InteractiveMapInitialisation {
        constructor(map) {
          this.mapContainer = map;
          this.mapElement;

          this.setMapTitle();

          this.interactivePaths = {};

          this.jsonData;
          this.handleJsonData();

          if (this.jsonData) this.initialiseInteractiveMap(this.jsonData);
      
          this.eventHandlerInstance;
        }
      
        initialiseInteractiveMap(jsonData) {
          if (!jsonData) return;

          //SETS JSON DATA IF DOESN'T EXIST 
          if (!this.jsonData) this.jsonData = jsonData;

          this.initialiseInteractivePaths();

          if (!this.interactivePaths) return;

          this.mapElement = this.mapContainer.querySelector('.mod-interactive-map__inner-container');
          this.setMapTabIndex(this.mapElement);
          runPassRateScript(mapJsonDataURL);
          this.eventHandlerInstance = new InteractiveMapEventHandler(this.mapContainer, this.mapElement, this.interactivePaths);
        }


        handleJsonData = () => {
            mapJsonDataURL =  this.mapContainer.getAttribute('data-map-url');
            const jsonData = this.mapContainer.getAttribute('data-map-json');

            if (mapJsonDataURL) {
                // IF JSON ADDED AS A URL
                fetch(mapJsonDataURL)
                    .then(response => response.json())
                    .then(data => {
                        this.initialiseInteractiveMap(data);
                    })
                    .catch(error => {
                        console.error('Error fetching JSON data from URL:', error);
                    });
            } else if (jsonData) {
                //IF JSON ADDED AS A HTML ATTRIBUTE
                this.jsonData = JSON.parse(jsonData);
            } else {
                console.log('No JSON data or URL found for the map');
            }

        }

        handlePageResizing = () => {
            if (!this.interactivePaths) return;

            this.eventHandlerInstance.handlePageResizing();
        }

        setMapTitle = () => {
            //GET THE MAP TITLE ELEMENT
            const mapTitleElement = this.mapContainer.querySelector('.mod-interactive-map__title');
            const mapTitleValue = this.mapContainer.getAttribute('data-map-title');

            //CHECK MAP TITLE ATTRIBUTE EXISTS, IF SO, SET TITLE TEXT & TO VISIBLE
            if (mapTitleElement && mapTitleValue) {
                mapTitleElement.innerHTML = mapTitleValue;
                mapTitleElement.classList.remove('hidden'); 
            }
        }


        initialiseInteractivePaths = () => {
            const allPaths = this.mapContainer.querySelectorAll('path, polygon');

            //LOOP THROUGH ALL PATHS AND PASS ATTRIBUTE MATCHER HELPER THE PATH AND CALLBACK FUNCTION (TO CREATE PATH THE OBJECT)
            Array.from(allPaths).forEach(path => {
                InteractiveMapDefaultSetter.setDefaultPathColours(path)
                InteractiveMapHelpers.findMatchingAttributeHelper(path, this.createInteractivePathObject);
            });
        }


        createInteractivePathObject = (attribute, path) => {
            //CHECKS IF PATH HAS MATCHING ATTRIBUTE WITH KEY IN DATA
            const matchingEntry = Object.entries(this.jsonData).find(([key]) => key === attribute);

            if (!matchingEntry) return;

            const [matchingKey, value] = matchingEntry;

            //NOTE!: NEEDS TO SPLIT INTO ARRAYS AND SINGLE OBJECT AS POINT IS CALCULATED DIFFERENTLY DEPENDING!

            //IF KEY DOESN'T EXIST, SET EMPTY OBJECT
            if (!this.interactivePaths[matchingKey]) {
                //CREATE KEY
                this.interactivePaths[matchingKey] = {};
                //CREATE NEW KEYS FOR PATHS & DATA AND SET VALUES
                this.interactivePaths[matchingKey]['paths'] = path;
                this.interactivePaths[matchingKey]['tooltipData'] = value;
            } else {
                if (Array.isArray(this.interactivePaths[matchingKey].paths)) {
                    //IF PATH VALUE IS ALREADY, PUSH INTO ARRAY 
                    this.interactivePaths[matchingKey].paths.push(path);
                } else {
                    //ELSE CREATE NEW ARRAY FOR MATCHING KEY
                    this.interactivePaths[matchingKey].paths = [this.interactivePaths[matchingKey].paths, path];
                }
            }

            //SET INTERACTIVE COLOUR TO EACH PATH
            InteractiveMapDefaultSetter.setInteractivePathStateInactiveState(path);
        }

        setMapTabIndex = (mapElement) => {
            if (!mapElement) return;
            mapElement.setAttribute('tabIndex', 0);
        }
    }


    class InteractiveMapEventHandler {
        constructor(map, mapElement, interactivePaths) {
            this.mapContainer = map;
            this.mapElement = mapElement;
            this.interactivePaths = interactivePaths;

            this.interactionType;
            this.tabbingActivated;

            this.selectedPath;

            this.tabbablePaths = [];

            this.initialiseInteractivePathInstance(map, mapElement, interactivePaths);

            this.initialiseResizeInstance(mapElement);

            this.initialiseListeners(mapElement);

            this.pathInteractionInstance;
            this.resizeInstance;
        }


        initialiseInteractivePathInstance = (mapContainer, mapElement, interactivePaths) => {
            //SET UP INTERACTIVE PATH HANDLER INSTANCE
            this.pathInteractionInstance = new InteractiveMapPathInteractionHandler(mapContainer, mapElement, interactivePaths);
        }

        initialiseResizeInstance(mapElement) {
            this.resizeInstance = new InteractiveMapResizeHandler(mapElement, this.pathInteractionInstance);
        }

        handlePageResizing = () => {
            this.resizeInstance.handleTooltipOnResize();
            this.resizeInstance.debounceResizeHandler();
        }

        initialiseListeners = (mapElement) => {
            //CLICK EVENT
            mapElement.addEventListener('mousedown', (e) => {
                this.interactionType = 'mouse';
                this.handlePathInteraction(e);
                e.stopPropagation();
            }, true);

            mapElement.addEventListener('focus', () => {
                mapElement.addEventListener('keydown', this.handleMapKeyPressListener);
            });
        }
        
        handleMapKeyPressListener = (e) => {

            if (e.key === 'Enter') {

                this.tabbingActivated = true;
                this.interactionType = 'keyboard';

                //LET USER KNOW THEY ARE IN THE MAP
                this.mapElement.setAttribute('aria-label', 'You are now in the mapElement');
                this.mapElement.classList.add('focused');

                //ATTACH E LISTENER TO DOCUMENT TO CHECK WHEN FOCUS LEAVES THE MAP
                document.addEventListener('focusin', this.handleFocusOutOfMap);


                let tabbablePaths = [];
                for (const [key, { paths, tooltipData }] of Object.entries(this.interactivePaths)) {

                    const path = Array.isArray(paths) ? paths[0] : paths;

                    if (!this.tabbablePaths.includes(path)) {
                        tabbablePaths.push(path);

                        const index = tabbablePaths.length;

                        this.setFocusAttributes(path, index, tooltipData, key);
                        this.setPathFocusEListener(path);
                    }

                    //SETS TAB INDEX TO 0 TO ENABLE PATHS TO BE TABBABLE
                    InteractiveMapHelpers.setPathTabIndexHelper(path, 0);
                }

                this.tabbablePaths = tabbablePaths;

                e.target.blur();
                this.mapElement.removeEventListener('keydown', this.handleMapKeyPressListener);
            }
        }


        setFocusAttributes = (path, index, tooltipData, region) => {
            const parsedRegion = InteractiveMapHelpers.regionParser(region);

            const dataEntries = `${Object.entries(tooltipData).map(([key, val]) => `${key}: ${val.value}`).join(', ')}`;

            //SET ARIA LABELS
            path.setAttribute('aria-label', `Region: ${parsedRegion}, ${dataEntries ?? dataEntries}`);

            //TELLS USER HOW MANY REGIONS IN MAP AND WHAT ONE THEY'RE ON
            path.setAttribute('aria-posinset', index);
            path.setAttribute('aria-setsize', Object.keys(this.interactivePaths).length);

            //USED TO HANDLE CLICK INTERFERANCE WITHIN HANDLE PATH INTERACTION FUNCTION
            path.setAttribute('tabbable', true);

        }

        setPathFocusEListener = (path) => {
            path.addEventListener('focus', this.handleMapPathFocused);
        }

        handleMapPathFocused = (e) => {
            if (this.interactionType === 'keyboard') {
                this.handlePathInteraction(e);
            } else {
                //SETS THE INTERACTION TYPE BACK TO KEYBOARD (FUNCTION ONLY RAN WHEN USER TABBING)
                this.interactionType = 'keyboard';
            }
        }

        checkTargetIsSVG = (element) => {
            return element instanceof SVGPathElement || element instanceof SVGPolygonElement;
        }


        handlePathInteraction = (e) => {
            const self = this;

            setTimeout(function() {
                //CHECKS IF SVG

                if (!self.checkTargetIsSVG(e.target)) {
                    //SETS THE INTERACTION TYPE BACK TO KEYBOARD IF THE USER WAS TABBING
                    if (self.tabbingActivated) self.interactionType = 'keyboard';

                    self.pathInteractionInstance.handlePathNotInteracted(e.target);
                    return;         
                }

                //IF A USER CLICKS AN AREA THAT IS NOT TABBABLE, DO NOT SET ANYTHING
                if (!e.target.classList.contains('interactive')) {
                    //RESET THE INTERACTION TYPE TO KEYBOARD IF THE USER WAS TABBING
                    if (self.tabbingActivated) self.interactionType = 'keyboard';
                    return;
                }

                
                //SETS INTERACTION TYPE BACK TO KEYBOARD IF THE USER HAS CLICKED THE MAP WHILST TABBING
                if (self.tabbingActivated && !e.target.getAttribute('tabbable')) self.interactionType = 'keyboard';

                self.pathInteractionInstance.createPlotObject(e.clientX, e.clientY)

                InteractiveMapHelpers.findMatchingAttributeHelper(e.target, self.pathInteractionInstance.checkForMatchingEntry);

                //SET MUTATION CONTROLLER TO FALSE SO THAT THE UPDATE TO DATA-SELECTED-REGION DOESN'T RUN CHECKFORMATCHINGENTRY TWICE
                self.pathInteractionInstance.mutationController = true;

                self.mapContainer.setAttribute('data-selected-region', self.pathInteractionInstance.selectedRegion);
            }, 0)
        }


        removeFocusInteractionFromPaths = () => {
            if (this.tabbablePaths.length === 0) return;
            
            this.tabbablePaths.forEach(path => {
                //SETS TAB INDEX TO 0 TO ENABLE PATHS TO BE TABBABLE
                InteractiveMapHelpers.setPathTabIndexHelper(path, -1);
            })
        }


        handleFocusOutOfMap = (e) => {
            //FUNCTION RESETS MAP TO DEFAULT WHEN USER TABS OUT OF MAP
            if (this.mapElement.contains(e.target)) return;

            this.mapElement.classList.remove('focused');

            //RESET MAP INTERACTION STATE (SO USER IS NOT FORCED INTO TABBING THROUGH MAP AGAIN)
            this.removeFocusInteractionFromPaths();

            //SET BACK TO DEFAULT ATTRIBUTES
            InteractiveMapDefaultSetter.setDefaultMapAttributes(this.mapElement);

            //RESET VARIABLES
            this.interactionType = null;
            this.tabbingActivated = false;

            this.pathInteractionInstance.handlePathNotInteracted(null);

            //REMOVE FOCUS E-LISTENER FROM DOCUMENT
            document.removeEventListener('focusin', this.handleFocusOutOfMap);
        }
    }


    class InteractiveMapPathInteractionHandler {
        constructor (map, mapElement, interactivePaths) {
            this.mapContainer = map;
            this.mapElement = mapElement;
            this.interactivePaths = interactivePaths;

            this.tooltip = {
                container: null,
                box: null,
                title: null,
                content: null,
                plot: null,
                plotLine: null
            }

            this.themeProductColour;

            this.mutationController = false;

            this.SelectedRegion;
            this.SelectedPaths;
            this.tooltipData;

            this.previouslySelectedPaths;

            this.tooltipManagerInstance;

            this.setInteractionPathColour();
            this.initObservation(map);
            this.initTooltipInstance();
        }

        setInteractionPathColour = () => {
            const productUIColour = getComputedStyle(document.body).getPropertyValue('--themeUiProductColour');
            this.themeProductColour = productUIColour !== "#efefef" || !productUIColour ? productUIColour : '#58aae0';
        }

        initObservation = (mapContainer) => {
            //OBSERVES EACH MAP ON PAGE FOR CHANGES IN THE DATA-SELECTED-REGION ATTRIBUTE
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-selected-region') {
                        const region = mapContainer.getAttribute('data-selected-region');


                        if (!region) return this.toggleTooltipVisibility('visibility', false);

                        //IF MAP HEIGHT IS 0, EXIT (HANDLES TAB)
                        if (this.mapElement.offsetHeight === 0) return;


                        //IF INTERACTION WAS NOT BY CLICK CHECK FOR MATCH
                        if (!this.mutationController) {
                            this.createPlotObject();
                            this.checkForMatchingEntry(region);
                        }

                        //CHANGE PATH COLOUR
                        this.handlePathColourChange(); 

                        //SET TOOLTIP DATA;
                        this.handleTooltipCreation();

                        //RESET CONTROLLER
                        this.mutationController = false;
                      }
                });
            });

            observer.observe(mapContainer, {attributes: true});
        }

        initTooltipInstance = () => {
            //GET TOOLTIP
            const tooltip = this.mapContainer.querySelector('.mod-interactive-map__tooltip');

            if (!tooltip) return;

            this.tooltip.container = tooltip;
            this.tooltip.box = tooltip.querySelector('.mod-interactive-map__tooltip__info-box');
            this.tooltip.title = tooltip.querySelector('.mod-interactive-map__tooltip__info-box__title');
            this.tooltip.content = tooltip.querySelector('.mod-interactive-map__tooltip__info-box__content');
            this.tooltip.plot = tooltip.querySelector('.mod-interactive-map__tooltip__plot');
            this.tooltip.plotLine = tooltip.querySelector('.mod-interactive-map__tooltip__plot-line');

            this.tooltipManagerInstance = new InteractiveMapTooltipManager(this.mapContainer, this.mapElement, this.tooltip);
        }

        createPlotObject = (clientX, clientY) => {

            if (!this.tooltipManagerInstance) return;

            let plotPosition = {
                x: undefined,
                y: undefined
            }

            if (clientX && clientY) {
                //IF USER MOUSE CLICKED
                plotPosition.x = clientX;
                plotPosition.y = clientY;
            }

            this.tooltipManagerInstance.plotPosition = plotPosition;
        }


        previouslySelectedPathHandler = (newlySelectedRegion) => {
            //GET PREVIOUSLY SELECTED PATHS
            const previouslySelectedPaths = this.getSelectedPaths();

            //IF THERE ARE NO PRIOR PATHS SELECTED, RETURN TRUE
            if (!previouslySelectedPaths) return true;

            //IF NEWLY SELECTED REGION IS DIFFERENT AS CURRENT REGION, DIFFERENT SELECTED PATHS WILL BE TRUE, ELSE IS FALSE
            this.newPathSelected = newlySelectedRegion !== this.selectedRegion;

            if (this.newPathSelected) {
                //CALL FUNCTION TO DESELECT PREVIOUS PATHS
                this.removePaths(previouslySelectedPaths);
            } else {
                //STORE PREVIOUSLY SELECTED PATHS AS BEING REMOVED
                this.previouslySelectedPaths = this.selectedPaths;
            }

            //RETURN TRUE/FALSE
            return this.newPathSelected;
        }

        
        getSelectedPaths = () => {
                if (this.selectedRegion) return this.interactivePaths[this.selectedRegion].paths;
        }

        removeCurrentlySelectedPaths = () => {
            this.removePaths(this.selectedPaths);
            this.selectedPaths = null;
        }

        removePaths = (previouslySelectedPaths) => {
            setTimeout(function() {
                InteractiveMapHelpers.pathLooperHelper(previouslySelectedPaths, InteractiveMapHelpers.updatePathColourHelper, mapConfig.interactiveFillColourInactive);
            }, 0);
        }


        checkForMatchingEntry = (region) => {
            const matchingEntry = InteractiveMapHelpers.findSelectedRegionByAttributeHelper(this.interactivePaths, region);
            if (!matchingEntry) return;

            const [matchingRegion, {paths, tooltipData}] = matchingEntry;

            const newPathSelected = this.previouslySelectedPathHandler(matchingRegion);

            //IF NEW PATH, SET PATHS REGION AND TOOLTIP, ELSE REMOVE THEM
            if (newPathSelected) {
                this.selectedPaths = paths;
                this.selectedRegion = matchingRegion;
                this.tooltipData = tooltipData;
            } else {
                this.resetPathInteraction();
            }
        }


        resetPathInteraction = () => {
            this.selectedPaths = null;
            this.selectedRegion = null;
            this.tooltipData = null;
            this.toggleTooltipVisibility('visibility', false);
        }

        handleTooltipCreation = () => {
            //PASSES ALL DATA REQUIRED TO CREATE TOOLTIP TO TOOLTIP INSTANCE
            const self = this;

            setTimeout(function() {
                if (!self.selectedPaths || !self.tooltipManagerInstance) return;

                let selectedPath;
                if (Array.isArray(self.selectedPaths)) selectedPath = self.selectedPaths[0];
                self.tooltipManagerInstance.createTooltip(selectedPath || self.selectedPaths, self.tooltipData, self.selectedRegion);
            }, 0)
        }


        handlePathNotInteracted = (target) => {
            //IF NO REGION SELECTED, EXIT FUNCTION
            if (this.selectedRegion === null) return;

            //IF TOOLTIP CLICKED, DO NOTHING
            const { box, plot, plotLine } = this.tooltip;
            if (
                target === box || 
                box.contains(target) ||
                target === plot || 
                target === plotLine
            ) return;

            //REMOVE TOOLTIP
            this.toggleTooltipVisibility('visibility', false);
            
            //REMOVE COLOUR FROM PREVIOUS AREA
            const previouslySelectedPaths = this.getSelectedPaths();
            if (previouslySelectedPaths) this.removePaths(previouslySelectedPaths);

            //REMOVE SELECTED REGION
            this.selectedRegion = null;
            this.mapContainer.setAttribute('data-selected-region', '');
        }

        toggleTooltipVisibility = (type, visibility) => {

            if (type === 'visibility') InteractiveMapHelpers.toggleElementVisibility(this.tooltip.container, visibility);

            if (type === 'display') InteractiveMapHelpers.toggleElementDisplay(this.tooltip.container, visibility);
            
        }

        toggleTooltipDisplay = (displayed) => {
            InteractiveMapHelpers.toggleElementVisibility(this.tooltip.container, displayed);
        }


        handlePathColourChange = () => {
            let newPathColour;
            let paths = this.selectedPaths;

            if (this.selectedPaths) {
                newPathColour = this.themeProductColour ?? mapConfig.interactiveFillColourActive;
            } else {
                newPathColour = mapConfig.interactiveFillColourInactive;
                paths = this.previouslySelectedPaths;
                this.previouslySelectedPaths = null;
            }

            //SET PATH COLOUR TO NEW PATH COLOUR
            InteractiveMapHelpers.pathLooperHelper(paths, InteractiveMapHelpers.updatePathColourHelper, newPathColour);
        }
    }


    class InteractiveMapTooltipManager {
        constructor(map, mapElement, tooltip) {
            this.mapContainer = map;
            this.mapElement = mapElement;
            this.tooltip = tooltip;

            this.styleData;

            this.tooltipMargin = 20;

            this.plotPosition = {
                x: undefined,
                y: undefined
            };

            this.getStyleData();
        }

        getStyleData = () => {
            const styleString = this.mapContainer.getAttribute('data-tooltip-styles');
            if (styleString) this.styleData = JSON.parse(styleString);
        }

        createTooltip = (pathElem, data, region) => {
            this.updateTooltipPosition(pathElem);
            this.setTooltipData(data);
            this.setTooltipBoxTitle(region);
        }

        updateTooltipPosition = (pathElem) => {
            const self = this;

            setTimeout(() => {
                //FUNCTION THAT STARTS POSITIONING THE TOOLTIP

                const pathRect = pathElem.getBoundingClientRect();
                const mapRect = self.mapElement.getBoundingClientRect();
                const halfofPathHeight = pathRect.height / 2;

                //PATH POSITION RELATIVE TO MAP SVG
                const positionRelativeToParent = {
                    left: pathRect.left - mapRect.left,
                    top: pathRect.top - mapRect.top
                };

                const plotPosition = self.getPlotPosition(pathRect, positionRelativeToParent, halfofPathHeight, mapRect);

                //IF TOOLTIP SHOULD GO ABOVE/BELOW PATH
                self.checkPathRelativePosition(plotPosition, positionRelativeToParent, halfofPathHeight, pathRect, mapRect);

                //PASS COORDS (X,Y) FOR TOOLTIP POINT 
                self.positionTooltipPoint(plotPosition);

                InteractiveMapHelpers.toggleElementVisibility(self.tooltip.container, true);

            }, 0);
        }

        getPlotPosition = (pathRect, positionRelativeToParent, halfofPathHeight, mapRect) => {
            const {x, y} = this.getPlotCenter();

            let plotPosition = {
                x: 0,
                y: 0
            };

            if (this.plotPosition.x && this.plotPosition.y) {
                // USES X AND Y FOR WHERE USER HAS CLICKED
                plotPosition.x = this.plotPosition.x - mapRect.left - x;
                plotPosition.y = this.plotPosition.y - mapRect.top - y;
            } else {
                //USES X AND Y FOR MIDDLE OF PATH (TABBING)
                plotPosition.x = positionRelativeToParent.left + (pathRect.width / 2) - x;
                plotPosition.y = positionRelativeToParent.top + (halfofPathHeight - y);
            }

            return plotPosition;
        }

        getPlotCenter = () => {
            //RETURNS THE EXACT CENTER OF THE PLOT POINT
            const tooltipCenter = {
                x: this.tooltip.plot.offsetWidth / 2,
                y: this.tooltip.plot.offsetHeight / 2
            }
            return tooltipCenter;
        }


        checkPathRelativePosition = (plotPosition, positionRelativeToParent, halfofPathHeight, pathRect, mapRect) => {
            //CHECKS IF PATH CLICKED IS ABOVE/ BELOW HALF WAY POINT OF MAP
            const pathBelowMapCenter = positionRelativeToParent.top > this.mapElement.offsetHeight / 2;
            if (pathBelowMapCenter) {
                this.handlePathBelowMapCenter(plotPosition,positionRelativeToParent, halfofPathHeight, pathRect, mapRect);
            } else {
                this.handlePathAboveMapCenter(plotPosition, positionRelativeToParent, halfofPathHeight, pathRect, mapRect);
            }
        }
        
        handlePathAboveMapCenter = (plotPosition, positionRelativeToParent, halfofPathHeight, pathRect, mapRect) => {
            //PASS Y POSITION AND VALUES FOR X POSITION CALCULATION FOR TOOLTIP BOX POSITION
            this.positionTooltipBoxX(positionRelativeToParent.left, plotPosition.x, mapRect);

            const yPosition = plotPosition.y + halfofPathHeight + this.tooltipMargin;
            this.positionTooltipBoxY(yPosition, true);

            //PASS HEIGHT, X AND Y COORDS FOR TOOLTIP LINE
            const lineHeight = halfofPathHeight + this.tooltipMargin;
            this.positionTooltipLine(plotPosition.y, plotPosition.x, lineHeight);
        }

        handlePathBelowMapCenter = (plotPosition ,positionRelativeToParent, halfofPathHeight, pathRect, mapRect) => {
            //PASS Y POSITION AND VALUES FOR X POSITION CALCULATION FOR TOOLTIP BOX POSITION
            
            //BOX POSITIONING
            const boxYPosition = mapRect.height - (plotPosition.y - halfofPathHeight)
            this.positionTooltipBoxX(positionRelativeToParent.left, plotPosition.x, mapRect);
            this.positionTooltipBoxY(boxYPosition, false);

            //LINE POSITIONING
            const halfOfBoxHeight = this.tooltip.box.offsetHeight /2,
            lineStartPoint = plotPosition.y - halfofPathHeight - halfOfBoxHeight,
            lineHeight = halfofPathHeight + halfOfBoxHeight;

            this.positionTooltipLine(lineStartPoint, plotPosition.x, lineHeight);
        }

        positionTooltipBoxY = (yPosition, isAbove) => {
            //SET Y POSITION OF POPUP BOX (STRING VALUES IN PIXELS)
            if (isAbove) {
                this.tooltip.box.style.top = `${yPosition}px`;
                this.tooltip.box.style.bottom = `auto`;
            } else {
                this.tooltip.box.style.top = `auto`;
                this.tooltip.box.style.bottom = `${yPosition}px`;
            }
        }

        positionTooltipBoxX = (xPlot, plotPositionX, mapRect) => {
            const tooltipWidth = this.tooltip.box.offsetWidth;

            //QUARTER WIDTH OF TOOLTIP FOR PADDING
            const quarterTooltipWidth = tooltipWidth / 4;

            //IF PATH IS ON RIGHT SIDE OF MAP
            if (xPlot > mapRect.width / 2) {
                //CHANGE THE LEFT OF THE TOOLTIP BOX TO THE RIGHT SIDE OF THE LINE
                this.tooltip.box.style.left = `${plotPositionX - (quarterTooltipWidth * 3)}px`;
            } else {
                //IF TOOLTIP GOING OFF SCREEN (5 FOR A BIT OF PADDING)
                if (xPlot + tooltipWidth > mapRect.width - 5) {
                    //SET TOOLTIP BOX TO CENTER OF LINE
                    this.tooltip.box.style.left = `${plotPositionX - (tooltipWidth / 2)}px`;
                } else {
                    //CHANGE THE LEFT OF THE TOOLTIP BOX TO THE RIGHT SIDE OF THE LINE
                    this.tooltip.box.style.left = `${plotPositionX - quarterTooltipWidth}px`;
                }
            }
        }

        positionTooltipPoint = (plotPosition) => {
            //SET Y POSITION OF POPUP BOX
            this.tooltip.plot.style.top = `${plotPosition.y}px`;
            //SET X POSITION OF POPUP BOX
            this.tooltip.plot.style.left = `${plotPosition.x}px`;
        }
        
        positionTooltipLine = (yPosition, xPosition, lineHeight) => {
            //SET TOOLTIP LINE HEIGHT & TOP 
            this.tooltip.plotLine.style.top = `${yPosition}px`;
            this.tooltip.plotLine.style.height = `${lineHeight}px`;
            //X POSITION OF LINE IS X POSITION OF PLOT POINT PLUS HALF THE PLOT POINT WIDTH (MIDDLE OF PLOT)
            this.tooltip.plotLine.style.left = `${xPosition + (this.tooltip.plot.offsetWidth / 2 )}px`;
        }

        setTooltipData = (data) => {
            //ACCEPTS THE DATA TO BE ADDED TO THE TOOLTIP
            let contentHTML = '';

            const createSpanWithStyles = (text, styles) => {
                //LOOP THROUGH EACH ITEM IN STYLES OBJECT, SET KEY TO STYLE PROPERTY AND VALUE TO THE STYLE VALUE
                const styleString = styles ? Object.entries(styles).map(([prop, val]) => `${prop}: ${val}`).join('; ') : '';
                return `<span style="${styleString}">${text}</span>`;
            };

            //FOR EACH KEY IN IN THE JSON IN THE REGION USER CLICKED
            for (const key in data) {
                const valueObj = data[key];
        
                //IF VALUE NOT NULL AND IS OBJECT
                if (valueObj !== null && typeof valueObj === 'object') {

                    let valueString = valueObj.value;
                    //IF STYLETEXT EXIST UPDATE VALUESTRING WITH NEW STYLED SPANS (IF MATCHES EXIST)
                    if (valueObj.styledText) {
                        valueObj.styledText.forEach(({ value, style }) => {
                            
                            //IF STYLE VALUE EXISTS IN STYLE DATA, SET STYLES TO ADD TO STYLE DATA VALUE ELSE SET TO STYLES
                            const stylesToAdd = this.styleData && this.styleData[style] ? this.styleData[style] : style;

                            if (stylesToAdd) {
                                //MATCH DESIRED TEXT WITHIN ORIGINAL VALUE AND PASS TO CREATESPANFUNCTION
                                const regex = new RegExp(`(${value})`, 'g');
                                valueString = valueString.replace(regex, match => createSpanWithStyles(match, stylesToAdd));
                            }
                        });
                    }

                    //IF STYLE DATA OBJECT EXISTS, USE 
                    const stylesToAdd = this.styleData && this.styleData[valueObj.style] ? this.styleData[valueObj.style] : valueObj.style;

                    let valueHTML;
                    if (stylesToAdd) {
                        //IF STYLE KEY EXISTS IN OBJ, PASS TO STYLING FUNCTION
                        valueHTML = createSpanWithStyles(valueString, stylesToAdd);
                    } else {
                        valueHTML = `<span>${valueString}</span>`;
                    }
                    
                    contentHTML += valueHTML;
                }
            }
            //UPDATE INNERHTML OF TOOLTIP
            this.tooltip.content.innerHTML = contentHTML;
        };

        setTooltipBoxTitle = (region) => {
            //SET TOOLTIP TITLE TO REGION
            this.tooltip.title.innerHTML = InteractiveMapHelpers.regionParser(region);
        }
    }

    
    class InteractiveMapResizeHandler {
        constructor(map, pathInteractionInstance) {
            this.mapElement = map;
            this.pathInteractionInstance = pathInteractionInstance;
            
            this.isResizing;
        }

        debounce = (func, delay) => {
            //DEBOUNCE FUNCTION FOR RESIZE
            let timeoutId;
            return function (...args) {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    func(...args);
                }, delay);
            };
        }


        handleTooltipOnResize = () => {
            if (this.isResizing) return;

            //RESIZE STARTING
            this.isResizing = true;

            //SET TOOLTIP TO DISPLAY NONE WHEN RESIZING (DOESN'T CAUSE OVERFLOW ISSUES WITH LARGE TOOLTIPS)
            this.pathInteractionInstance.toggleTooltipVisibility('display', false);
        }

        debounceResizeHandler = this.debounce(() => {
            this.pathInteractionInstance.toggleTooltipVisibility('display', true);

            if (this.mapElement.offsetHeight == 0) {
                this.pathInteractionInstance.removeCurrentlySelectedPaths();
                this.pathInteractionInstance.toggleTooltipVisibility('visibility', false);
                return;
            }


            //RECALC THE TOOLTIP POSITION ONCE RESIZE IS DONE
            if (this.pathInteractionInstance.selectedRegion) {

                //RESET PLOT POINT TO NULL SO THAT THE TOOLTIP CAN BE POSITIONED TO CENTER OF PATH ELEMENT
                this.pathInteractionInstance.createPlotObject();

                //SET TOOLTIP POSITION
                this.pathInteractionInstance.handleTooltipCreation();
            }

            //RESIZE FINISHED
            this.isResizing = false;
        }, 200);
    }


    const mapInstances = [];
    maps.forEach(mapSVG => {
        const map = new InteractiveMapInitialisation(mapSVG);
        mapInstances.push(map);
    });

    window.addEventListener('resize', () => {
        mapInstances.forEach(mapInstance => {
            mapInstance.handlePageResizing();
        });
    });

    if (typeof cnfsdInteractiveMApLoaded === 'undefined') {
		window.cnfsdInteractiveMApLoaded = true;
	}
});